import React, { useState } from "react";
import "./Contact.css";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbz-j12eEgrrCzPxtO51QOLClMWJSP6CwOULf2ciPAetx-cKu7-VYyVZ_cMnJ9w_JHFY/exec",
        {
          method: "POST",
          body: JSON.stringify(formData),
        }
      );

      alert("✅ Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: ""
      });
    } catch (error) {
      alert("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {/* 🔥 HIGH LEVEL SEO */}
      <Helmet>
        <title>
          Contact Lush Desire | Discreet Adult Store Support India
        </title>

        <meta
          name="description"
          content="Contact Lush Desire for support, queries & orders. Buy adult products online in India with discreet delivery. Reach us via phone, email or contact form."
        />

        <meta
          name="keywords"
          content="
          contact adult store india,
          lush desire contact,
          adult toys customer support india,
          sex toys help india,
          discreet adult products india,
          adult store delhi,
          adult store mumbai,
          adult store bangalore,
          adult store hyderabad,
          adult store chennai,
          adult store pune,
          adult store kolkata
          "
        />

        <link rel="canonical" href="https://lushdesire.in/contact" />
      </Helmet>

      <div className="contact-page">
        <section className="contact-container">

          {/* 🔥 SEO H1 */}
          <h1>Contact Lush Desire – Adult Wellness Store India</h1>

          <div className="contact-content">

            {/* LEFT INFO */}
            <div className="contact-info">
              <h2>Get In Touch</h2>
              <p>Customer support available: 10 AM – 6 PM</p>

              <p>
                <strong>Email :</strong> lushdesire19@gmail.com
              </p>
              <p>
                <strong>Phone :</strong> 8505893556
              </p>

              <p>
                We provide discreet support across India including Delhi,
                Mumbai, Bangalore, Hyderabad, Chennai, Pune & Kolkata.
              </p>
            </div>

            {/* FORM */}
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div>
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <label>Phone Number</label>
              <input
                type="text"
                name="phone"
                placeholder="Your Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />

              <label>Message</label>
              <textarea
                name="message"
                placeholder="Write your message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <button type="submit">
                Send Message →
              </button>
            </form>

          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
